/**
 * Optional field: empty passes; non-empty must be alphanumeric only (trimmed).
 * Matches legacy checks used for prescriber provider number in ProfileForm.
 */
export const validateOptionalAlphanumericTrim = (
  value: string | undefined,
  invalidMessage: string
): true | string => {
  if (!value) {
    return true
  }
  const str = String(value)
  return /^[a-zA-Z0-9]*$/i.test(str.trim()) || invalidMessage
}
